import { Component, OnInit, Input, ViewChild, ViewChildren, ElementRef, QueryList, AfterViewInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { ModuleComponent } from '../module/module.component';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.css']
})
export class ModulesComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() modulesURL: string;
  /**
   * Records fetched per request. Previously this was an @Input that the component
   * immediately overwrote with a figure derived from measuring the DOM, so the value
   * callers passed had no effect. It is honoured now.
   *
   * Kept small deliberately: the first paint should not cost a phone a large download.
   * More arrive as the user scrolls.
   */
  @Input() modulesPerPage = 6;
  @Input() dashboard: boolean = false;
  @ViewChild('modulescontainer') modulesContainer: ElementRef;
  @ViewChildren('modulecontainer') moduleContainer: QueryList<ElementRef>;
  @ViewChildren('moduleComponent') moduleComponents: QueryList<ModuleComponent>;
  @Input() modules: any[];
  @Input() inPackage: boolean = false;
  @Input() currentUserIsAdmin: boolean = false;
  @Output() deleteClicked = new EventEmitter<any>();
  scrollingFunction;
  coursesfinished = false;
  loading = false;
  @Input() isUserModulesControl = false;
  initialloaddone = false;

  constructor(private modulemanager: ModulemanagementService) { }

  get scollingBody(){
    let scrollingbody =  document.getElementById('home-main-wrap');
    if(scrollingbody && window.innerWidth <= 767){//767 because that's the value used in home.component.css
      scrollingbody = scrollingbody.parentElement;
    }
    return scrollingbody;
  }

  async ngAfterViewInit() {
    await this.load();
    this.initialloaddone = true;

    // Only a URL-backed list pages; one given its modules directly has nothing to fetch.
    if (this.modulesURL && !this.dashboard) {
      this.scrollingFunction = this.scrolling.bind(this);
      this.scollingBody?.addEventListener('scroll', this.scrollingFunction);
    }
  }

  ngOnInit(): void {
    if(this.modules === undefined){
      this.modules = [];
    }
  }

  hasModules() {
    return this.modules && this.modules.length > 0
  }

  ngOnDestroy(): void {
    // guarded: the getter reads an element that may already be gone during teardown, and
    // the listener is only attached for URL-backed lists
    if (this.scrollingFunction) {
      this.scollingBody?.removeEventListener('scroll', this.scrollingFunction);
    }
  }

  async load() {
    this.modules = [];
    await this.loadMoreModules();
  }

  async reload() {
    this.modules = [];
    this.coursesfinished = false;
    await this.loadMoreModules();
  }

  needsMoreCoursesOnScreen() {
    const body = this.scollingBody;
    if (!body) {
      return false;
    }
    const scrollPercent = (body.scrollTop / (body.scrollHeight - body.clientHeight)) * 100;
    return scrollPercent > 70;
  }

  /**
   * Loads the next page as the user nears the bottom.
   *
   * This used to also test the scroll *direction*, comparing the container's position
   * against `scrollY` — which is not a field on this component but `window.scrollY`, and
   * which it then tried to assign to. The comparison was meaningless and the assignment
   * silently failed. Nearing the bottom is the condition that actually matters, and it is
   * what the other infinite-scroll lists in this app use.
   */
  scrolling() {
    if (this.needsMoreCoursesOnScreen() && !this.coursesfinished && !this.loading) {
      this.loadMoreModules();
    }
  }

  async loadMoreModules() {
    if (!this.modulesURL || this.loading) {
      return;
    }
    this.loading = true;
    try {
      const data: any = await this.modulemanager
        .getModules(this.modulesURL, this.modules.length, this.modulesPerPage)
        .toPromise();

      if (data.length > 0) {
        this.modules.push(...data);
      }
      else {
        this.coursesfinished = true;
      }
    }
    finally {
      this.loading = false;
    }
  }

  deleteClickedFired(module){
    this.deleteClicked.emit(module);
  }
}
